// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".source-properties-table td {\n    border-bottom: none;\n}\n\n.source-field-description {\n    margin: 10px;\n}\n\n.source-field-header {\n    font-weight: 700;\n    margin-top: 4px;\n}\n\nsource-field-value {\n    font-weight: normal;\n    margin-bottom: 4px;\n}\n\n.source-field-title {\n    font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
